<template>
  <div class="row" v-if="showProperty">
    <label :for="prop.prop_name" class="label" v-if="prop.label">
      {{ prop.label }}
      <span class="req" v-if="prop.required">*</span>
      <button :data-balloon="tooltipText" class="tooltip" data-balloon-pos="right" v-if="tooltipText">
        <i class="fa fa-info-circle"></i>
      </button>
    </label>

    <schema-section
      :internal="internal"
      :page="parent"
      :section="prop"
      :single="true"
      @add="$parent.$parent.addItem(prop)"
      @delete="$parent.$parent.deleteItem(parent, prop, $event)"
      @editing="$parent.$parent.editSection(prop, $event)"
      @reorder="$parent.$parent.reorderItems(parent, prop, $event)"
      @save="$parent.$parent.saveSection(parent, prop, $event)"
      v-if="prop.type == 'list'"
    />

    <div :class="['input', prop.error ? 'input_error' : '']" v-if="prop.type != 'list'">
      <!-- filter.type: 'cbo' -->
      <select
        class="txt txt-reg filter"
        @change="filterChange"
        v-model="filter_value"
        v-if="prop.filter && prop.filter.type == 'cbo'"
      >
        <option v-if="prop.type == 'checklist'" value="">Choose {{ prop.filter.label }}</option>
        <option
          :item="JSON.stringify(item)"
          :key="index"
          :value="item[prop.filter.value_prop] || item.ItemID || item._listText"
          v-for="(item, index) in filterItems"
        >
          {{ item._listText }}
        </option>
      </select>

      <!-- text -->
      <input
        :disabled="prop.disabled || (prop.insert_only && !adding)"
        :id="prop.prop_name"
        @blur="inputBlur"
        class="txt txt-reg"
        type="text"
        v-if="prop.type == 'text'"
        v-model="parent[prop.prop_name]"
        :maxlength="prop.maxlength"
      />

      <!-- number -->
      <input
        :disabled="prop.disabled"
        :id="prop.prop_name"
        @blur="inputBlur"
        class="txt txt-reg"
        type="number"
        v-if="prop.type == 'number'"
        v-model.number="parent[prop.prop_name]"
      />

      <!-- price -->
      <input
        :id="prop.prop_name"
        @blur="inputBlur"
        class="txt txt-reg"
        type="number"
        v-if="prop.type == 'price'"
        v-model.number="parent[prop.prop_name]"
      />

      <!-- email -->
      <input
        :id="prop.prop_name"
        @blur="inputBlur"
        class="txt txt-reg"
        type="email"
        v-if="prop.type == 'email'"
        v-model="parent[prop.prop_name]"
      />

      <!-- tel -->
      <input
        :id="prop.prop_name"
        class="txt txt-reg"
        type="tel"
        v-if="prop.type == 'tel'"
        v-model="parent[prop.prop_name]"
        :maxlength="prop.maxlength"
      />

      <!-- date -->
      <flat-pickr
        :disabled="prop.disabled"
        :config="flatpickrconfig"
        class="txt txt-reg"
        v-if="prop.type == 'date'"
        v-model="parent[prop.prop_name]"
      ></flat-pickr>

      <!-- time -->
      <input
        :id="prop.prop_name"
        @blur="inputBlur"
        class="txt txt-reg"
        type="time"
        v-if="prop.type == 'time'"
        v-model="parent[prop.prop_name]"
      />

      <!-- date-ms -->
      <flat-pickr
        :config="flatpickrmsconfig"
        :id="prop.prop_name"
        class="txt txt-reg"
        v-if="prop.type == 'date-ms'"
        v-model="parent[prop.prop_name]"
        v-on:blur="dateBlur"
      ></flat-pickr>

      <!-- password -->
      <input
        :id="prop.prop_name"
        class="txt txt-reg"
        type="password"
        v-if="prop.type == 'password'"
        v-model="parent[prop.prop_name]"
        :maxlength="prop.maxlength"
      />

      <!-- textarea -->
      <textarea
        :id="prop.prop_name"
        @blur="inputBlur"
        class="txt txt-reg"
        v-if="prop.type == 'textarea'"
        v-model="parent[prop.prop_name]"
        :maxlength="prop.maxlength"
      ></textarea>

      <!-- editor -->
      <!-- <vue-ckeditor :config="ckconfig" :editors="editors" type="classic" v-if="prop.type == 'editor'" v-model="parent[prop.prop_name]"></vue-ckeditor> -->
      <textarea
        :id="'ck4' + prop.prop_name + page.ItemID + parent._id"
        v-if="prop.type == 'editor'"
        v-model="parent[prop.prop_name]"
      ></textarea>

      <!-- editor5 -->
      <!-- <vue-ckeditor5 :config="ck5config" :editors="editor5s" type="classic" v-if="prop.type == 'editor'" v-model="page[prop.prop_name]"></vue-ckeditor5> -->
      <!-- chk -->
      <input
        :id="prop.prop_name"
        class="chk"
        type="checkbox"
        v-if="prop.type == 'chk'"
        v-model="parent[prop.prop_name]"
      />

      <!-- image or file -->
      <template v-if="prop.type == 'image' || prop.type == 'file'">
        <img
          :src="parent[prop.prop_name]"
          @load="imageLoaded"
          class="uploaded-img"
          v-if="prop.type == 'image' && parent[prop.prop_name] && !Array.isArray(parent[prop.prop_name])"
        />
        <img
          :key="i"
          :src="image"
          @load="imageLoaded"
          class="uploaded-img"
          v-for="(image, i) in parent[prop.prop_name]"
          v-if="prop.type == 'image' && parent[prop.prop_name] && Array.isArray(parent[prop.prop_name])"
        />
        <a
          :href="parent[prop.prop_name]"
          class="file-link"
          target="_blank"
          v-if="prop.type == 'file' && parent[prop.prop_name]"
        >
          <i class="fa fa-external-link"></i> Open file
        </a>
        <a
          @click.prevent="cropImage"
          class="crop"
          href
          v-if="
            prop.type == 'image' &&
            parent[prop.prop_name] &&
            !Array.isArray(parent[prop.prop_name]) &&
            prop.sizing == 'exact' &&
            prop.width &&
            prop.height
          "
        >
          <i class="fa fa-crop"></i> Crop image
        </a>
        <button
          @click="showDeleteFileModal = true"
          class="btn btn-delete"
          v-if="parent[prop.prop_name] && !prop.required"
        >
          <i class="fa fa-trash"></i>
        </button>
        <drop-zone
          :filetype="prop.file_types || (prop.type == 'file' ? 'application/pdf' : '')"
          :internal="internal"
          :page="parent"
          :prop="prop"
        ></drop-zone>
      </template>

      <!-- checklist -->
      <div class="checklist" v-if="prop.type == 'checklist'">
        <span
          :key="option.value || option.value == '' ? '__key__' : option"
          class="checklist-item"
          v-for="option in prop.options"
        >
          <label :for="option.value || option.value == '' ? '__key__' : option" class="label">{{
            option.text || option
          }}</label>
          <div class="input">
            <input
              :id="option.value || option.value == '' ? '__key__' : option"
              :value="option.value || option"
              class="checkbox"
              type="checkbox"
              v-model="parent[prop.prop_name]"
            />
          </div>
        </span>
        <span :key="index" class="checklist-item" v-for="(item, index) in _listItems">
          <label :for="prop.prop_name + (item._id || item.ItemID)" class="label">{{ item._listText }}</label>
          <div class="input">
            <input
              :id="prop.prop_name + (item.ItemID || item._id)"
              :value="item.ItemID || item._id"
              class="checkbox"
              type="checkbox"
              v-model="parent[prop.prop_name]"
            />
          </div>
        </span>
      </div>

      <!-- cbo -->
      <select
        :id="prop.prop_name"
        @change="updateDisplayText"
        class="txt txt-reg"
        v-if="prop.type == 'cbo'"
        v-model="parent[prop.prop_name]"
      >
        <option
          :key="option.value || option.value == '' ? '__key__' : option"
          :value="option.value || option"
          v-for="option in prop.options"
        >
          {{ option.text || option }}
        </option>
        <option
          :item="JSON.stringify(item)"
          :key="index"
          :value="item[prop.value_prop] || item.ItemID || item._listText"
          v-for="(item, index) in _listItems"
        >
          {{ item._listText }}
        </option>
      </select>

      <!-- colourpicker -->
      <a
        :id="'picker-' + prop.prop_name"
        :style="{ backgroundColor: parent[prop.prop_name] }"
        @click.prevent
        class="button colourpicker"
        href="#"
        v-if="prop.type == 'colourpicker'"
        >Choose colour</a
      >

      <p class="par_error" v-show="prop.error == 'required'">
        <i class="fa fa-warning"></i>
        {{ prop.label }} is required
      </p>
      <p class="par_error" v-show="prop.error == 'unique'">
        <i class="fa fa-warning"></i>
        {{ prop.label }} must be unique
      </p>
      <p class="par_error" v-show="prop.error == 'email'">
        <i class="fa fa-warning"></i>
        {{ prop.label }} must be a valid email address
      </p>
      <p class="par_error" v-show="prop.error == 'price'">
        <i class="fa fa-warning"></i>
        {{ prop.label }} must be a valid price
      </p>
      <p class="par_error" v-show="prop.error == 'number'">
        <i class="fa fa-warning"></i>
        {{ prop.label }} must be a valid number
      </p>
      <p class="par_error" v-show="prop.error == 'geo'">
        <i class="fa fa-warning"></i>
        The address cannot be found
      </p>
    </div>
    <modal-yes-no
      :message="'Are you sure you want to delete this file?'"
      :show="showDeleteFileModal"
      @close="showDeleteFileModal = false"
      @yes="removeImage"
    ></modal-yes-no>
  </div>
</template>

<script>
import api from "@/services/api"
import format from "@/format"
import ClassicEditor5 from "@ckeditor/ckeditor5-build-classic"
import VueCKEditor5 from "vue-ckeditor5"
// import ck4 from "ckeditor"
import DropZone from "./DropZone"
import DropZoneMulti from "./DropZoneMulti"
import "vue2-dropzone/dist/vue2Dropzone.min.css"
import ModalYesNo from "@/components/ModalYesNo.vue"
import flatPickr from "vue-flatpickr-component"
import "flatpickr/dist/flatpickr.css"
import Picker from "vanilla-picker"

export default {
  name: "SectionProperty",
  props: ["page", "parent", "prop", "internal", "sectiontype", "adding"],
  components: {
    "vue-ckeditor5": VueCKEditor5.component,
    DropZone,
    DropZoneMulti,
    flatPickr,
    SchemaSection: () => import("@/components/SchemaSection.vue"),
    ModalYesNo
  },
  data: function () {
    return {
      listItems: [],
      filterItems: [],
      filter_value: "",
      showDeleteFileModal: false,
      editor5s: {
        classic: ClassicEditor5
      },
      ck5config: {
        // CK5 Config here
      },
      flatpickrconfig: {
        // https://flatpickr.js.org/options/
        dateFormat: "d/m/Y",
        allowInput: true
      },
      flatpickrmsconfig: {
        // https://flatpickr.js.org/options/
        altFormat: "d/m/Y",
        altInput: true,
        dateFormat: "U",
        allowInput: true
      },
      crop: false
    }
  },
  created: function () {
    if (this.prop.type == "editor") {
      this.$nextTick(() => {
        if (this.internal) uploadurl = uploadurl + "&internal=1"

        const ck4Config = {
          versionCheck: false,
          allowedContent: true,
          youtube_responsive: true,
          youtube_related: false,
          youtube_privacy: true,
          extraPlugins: "image2,uploadimage,justify",
          removePlugins: "image",
          format_tags: "p;h1;h2;h3;h4;address;div",

          filebrowserUploadUrl: api.uploadCKURL(),
          filebrowserImageUploadUrl: api.uploadCKURL(),

          // Upload dropped or pasted images to the CKFinder connector (note that the response type is set to JSON).
          uploadUrl: api.uploadCKURL()
        }

        CKEDITOR.plugins.addExternal("youtube", "/ckplugins/youtube/", "plugin.js")
        CKEDITOR.replace("ck4" + this.prop.prop_name + this.page.ItemID + this.parent._id, ck4Config)
        // CKEDITOR.instances["ck4" + this.prop.prop_name + this.page.ItemID + this.parent._id].setData(this.parent[this.prop.prop_name])
        CKEDITOR.on("instanceReady", (evt) => {
          CKEDITOR.instances["ck4" + this.prop.prop_name + this.page.ItemID + this.parent._id].on("blur", () => {
            let ckeditorData =
              CKEDITOR.instances["ck4" + this.prop.prop_name + this.page.ItemID + this.parent._id].getData()
            this.parent[this.prop.prop_name] = ckeditorData
          })
          CKEDITOR.instances["ck4" + this.prop.prop_name + this.page.ItemID + this.parent._id].on("change", () => {
            let ckeditorData =
              CKEDITOR.instances["ck4" + this.prop.prop_name + this.page.ItemID + this.parent._id].getData()
            this.parent[this.prop.prop_name] = ckeditorData
          })
        })
      })
    }

    if (this.prop.type == "colourpicker") {
      if (!this.parent[this.prop.prop_name]) this.$set(this.parent, this.prop.prop_name, "")

      this.$nextTick().then(() => {
        var parent = document.querySelector("#picker-" + this.prop.prop_name)
        var picker = new Picker({
          parent,
          popup: "top",
          alpha: false,
          color: this.parent[this.prop.prop_name],
          onDone: (color) => (this.parent[this.prop.prop_name] = color.hex)
        })
      })
    }

    var listItems = []
    if (this.prop.type == "checklist" || (this.prop.type == "cbo" && this.prop.items)) {
      if (!this.parent[this.prop.prop_name]) this.$set(this.parent, this.prop.prop_name, [])

      listItems.push(
        this.getlistItems(this.prop.items, this.prop.list_text).then((res) => {
          this.listItems = res.filter((item) => {
            // Don't show this page in dropdown
            return item.ItemID ? item.ItemID != this.page.ItemID : true
          })
          if (this.prop.sort) {
            this.listItems.sort((a, b) => {
              var textA = a._listText.toUpperCase()
              var textB = b._listText.toUpperCase()
              return textA < textB ? -1 : textA > textB ? 1 : 0
            })
          }
        })
      )
    }

    if (this.prop.filter && this.prop.filter.type == "cbo") {
      listItems.push(
        this.getlistItems(this.prop.filter.items, this.prop.filter.list_text).then((res) => {
          this.filterItems = res.filter((item) => {
            // Don't show this page in dropdown
            return item.ItemID ? item.ItemID != this.page.ItemID : true
          })
          if (this.prop.filter.sort) {
            this.filterItems.sort((a, b) => {
              var textA = a._listText.toUpperCase()
              var textB = b._listText.toUpperCase()
              return textA < textB ? -1 : textA > textB ? 1 : 0
            })
          }
        })
      )

      Promise.all(listItems).then(() => {
        // Select filter cbo value if prop is cbo
        if (this.prop.type == "cbo") {
          var matching = this.listItems.filter(
            (i) => (i[this.prop.value_prop] || i.ItemID || i._listText) == this.page[this.prop.prop_name]
          )

          if (matching.length) {
            matching = matching[0]
            this.filter_value = matching[this.prop.filter.prop]
          }
        }
      })
    }

    if (this.prop.type == "price")
      this.parent[this.prop.prop_name] = parseFloat(this.parent[this.prop.prop_name]).toFixed(2)
  },
  computed: {
    _listItems() {
      if (!this.prop.filter) return this.listItems

      var items = []
      if (this.prop.filter.type) {
        if (this.prop.filter.type == "exclude") {
          items = this.listItems.filter((item) => !this.prop.filter.values.includes(item[this.prop.filter.prop]))
        }
        if (this.prop.filter.type == "cbo") {
          if (this.filter_value) {
            items = this.listItems.filter((item) => item[this.prop.filter.prop] == this.filter_value)
          } else if (this.prop.type == "checklist") {
            items = this.listItems.filter(
              (item) => this.page[this.prop.prop_name].indexOf(item.ItemID || item._id) > -1
            )
          }
        }
      } else {
        items = this.listItems.filter(
          (item) => item[this.prop.filter.item_attribute] == this.parent[this.prop.filter.page_attribute]
        )
      }

      return items
    },
    tooltipText() {
      var tt = this.prop.tooltip
      var mw = this.prop.width
      var mh = this.prop.height

      if (!(this.prop.tooltip || mw || mh)) return ""

      var text = tt ? tt : ""
      if (text && (mw || mh)) text = text + " "

      if (mw || mh)
        text =
          text +
          "The suggested size is " +
          (mw && mh ? mw + " x " + mh : mw ? mw + " pixels wide" : mh ? mh + " pixels high" : "")

      return text
    },
    showProperty() {
      if (this.page._home && this.prop.prop_name == "url" && this.prop.format == "page_url") return false

      return true
    }
  },
  methods: {
    filterChange() {
      if (this.prop.type == "cbo") this.page[this.prop.prop_name] = ""
    },
    processedListText(options) {
      var list_text = options

      if (!list_text) list_text = [{ type: "attribute", value: "name" }]

      if (typeof list_text === "string") return (list_text = [{ type: "attribute", value: list_text }])

      if (typeof list_text === "object" && !Array.isArray(list_text)) list_text = [list_text]

      if (Array.isArray(list_text)) {
        return list_text
      }

      return [{ type: "attribute", value: "name" }]
    },
    listTextAttributes(options) {
      return this.processedListText(options)
        .filter((val) => val.type == "attribute")
        .map((val) => val.value)
    },
    listText(item, options) {
      var list_text = this.processedListText(options)

      var text = []
      list_text.forEach((val) => {
        switch (val.type) {
          case "attribute":
            text.push(item[val.value])
            break
          case "literal":
            text.push(val.value)
            break
        }
      })

      return text.join(" ")
    },
    dateBlur(date) {
      var event = new KeyboardEvent("keydown", {
        view: window,
        keyCode: 13,
        bubbles: true,
        cancelable: true
      })
      var elem = document.getElementById(this.prop.prop_name).nextSibling
      elem.dispatchEvent(event)
    },
    updateDisplayText(e) {
      if (this.prop.background_prop) {
        var item = JSON.parse(e.target.options[e.target.options.selectedIndex].getAttribute("item"))
        this.$set(this.parent, this.prop.background_prop.prop_name, item[this.prop.background_prop.item_prop])
      }

      if (e.target.options.selectedIndex > -1)
        this.parent._display_text = e.target.options[e.target.options.selectedIndex].innerHTML
    },
    inputBlur() {
      var parent = this.parent
      var prop_name = this.prop.prop_name

      // If editing a page, copy name to title and url
      if (parent.ItemID) {
        if (prop_name == "name" && parent.hasOwnProperty("title") && parent.title.trim() == "")
          parent.title = parent[prop_name]
        if (prop_name == "name" && !parent._home && parent.hasOwnProperty("url") && parent.url.trim() == "")
          parent.url = format.page_url(parent[prop_name])
      }

      if (this.prop.format) parent[prop_name] = format[this.prop.format](parent[prop_name])

      if (this.prop.unique && this.parent[prop_name]) {
        api.isDuplicateValue("page", parent.ItemID, prop_name, parent[prop_name]).then((response) => {
          response ? this.$set(this.prop, "error", "unique") : this.$set(this.prop, "error", "")
        })
      }

      if (this.prop.geocode) {
        this.$store.commit(
          "addPromise",
          api.geocode(this.parent[prop_name]).then((response) => {
            if (response.data.status == "OK") {
              this.$set(this.prop, "error", "")

              if (!parent._geo) parent._geo = {}
              parent._geo[prop_name] = {}
              parent._geo[prop_name].lat = response.data.results[0].geometry.location.lat
              parent._geo[prop_name].lng = response.data.results[0].geometry.location.lng
            } else {
              this.$set(this.prop, "error", "geo")

              if (parent._geo) delete parent._geo["prop_name"]
            }
          })
        )
      }
    },
    imageLoaded() {},
    getlistItems: function (allitems, list_text) {
      return new Promise((resolve, reject) => {
        var promises = []

        if (!Array.isArray(allitems)) allitems = [allitems]

        allitems.forEach((items) => {
          var projection = this.listTextAttributes(list_text)
            .filter((a) => a != "ItemID" && a != "ItemType" && a != "name" && a != "hide")
            .join(",")

          if (items.attribute == "ItemType") {
            items.values.forEach((value) =>
              promises.push(
                api.getPages(value.split(".")[1], projection).then((res) => {
                  res.forEach((item) => (item._listText = this.listText(item, list_text)))
                  return res
                })
              )
            )
          }

          if (items.attribute == "ParentID") {
            items.values.forEach((value) => {
              console.log(value)
              promises.push(
                api.getSubPages(value.type, value.parent).then((res) => {
                  res.forEach((item) => (item._listText = this.listText(item, list_text)))
                  return res
                })
              )
            })
          }

          if (items.attribute == "ItemID")
            items.values.forEach((value) =>
              promises.push(
                api.getPage(value).then((res) => {
                  if (items.prop_name) {
                    res[items.prop_name].forEach((item) => (item._listText = this.listText(item, list_text)))
                    return res[items.prop_name]
                  } else if (items.single) {
                    res._listText = this.listText(res, list_text)
                    return res
                  } else {
                    res.items.forEach((item) => (item._listText = this.listText(item, list_text)))
                    return res.items
                  }
                })
              )
            )
        })

        Promise.all(promises).then((vals) => {
          var ret = []
          vals.forEach((val) => (ret = ret.concat(val)))
          resolve(ret)
        })
      })
    },
    removeImage() {
      this.parent[this.prop.prop_name] = ""
    },
    cropImage() {
      var image = this.parent[this.prop.prop_name]
      var width = this.prop.width
      var height = this.prop.height
      this.$store.commit("setImageToCrop", {
        image: { image, width, height },
        obj: this.parent,
        prop: this.prop.prop_name
      })
      this.$nextTick().then(() => {
        this.$store.commit("setCropper", { width, height })
      })
    }
  }
}
</script>
